<div class="help-container">
  <ng-content></ng-content>
</div>